<div class="col-md-12 px-0">
    <h2 class="mb-2">{{data.header}}</h2>
    <p>{{data.msg}}</p>
    <div class="row">
        <div class="col-md-6"><button class=" cancel lgbtn" id="openAlert"
                (click)="Cancel()"><span>Cancel</span></button>
        </div>
        <div class="col-md-6"><button class="cnfirm lgbtn primaryButton1" id="closedAlert"
                (click)="doLogOut()"><span>Yes</span></button>
        </div> 
    </div>
</div>